// Alert 层级管理
export const ALERT_Z_INDEX = {
  LOGIN: 1002,      // 登录页面 Alert
  REGISTER: 1002,   // 注册页面 Alert (与登录页同级)
  MY_WORK: 10000,   // 我的作品页面 Alert (确保在 Modal 之上，Modal 默认 z-index 为 1000)
  VOICE_CLONE: 1001, // 音色克隆页面 Alert
  LISTEN_SOUND: 1001, // 音色试听页面 Alert
  UPLOAD_VIDEO: 20000, // 视频上传页面 Alert (最高优先级，确保在所有弹窗之上)
  NAVBAR: 9999,     // 导航栏退出登录 Alert
} as const;

// Alert 类型
export type AlertType = 'success' | 'error' | 'info' | 'warning';

// Alert 配置接口
export interface AlertConfig {
  type: AlertType;
  message: string;
  duration?: number;
  closable?: boolean;
}

// 全局 Alert 管理器
class AlertManager {
  private static instance: AlertManager;
  private alerts: Map<string, AlertConfig> = new Map();

  static getInstance(): AlertManager {
    if (!AlertManager.instance) {
      AlertManager.instance = new AlertManager();
    }
    return AlertManager.instance;
  }

  // 显示 Alert
  show(id: string, config: AlertConfig): void {
    this.alerts.set(id, config);
  }

  // 隐藏 Alert
  hide(id: string): void {
    this.alerts.delete(id);
  }

  // 获取 Alert
  get(id: string): AlertConfig | undefined {
    return this.alerts.get(id);
  }

  // 获取所有 Alert
  getAll(): Map<string, AlertConfig> {
    return this.alerts;
  }

  // 清除所有 Alert
  clear(): void {
    this.alerts.clear();
  }
}

export default AlertManager.getInstance(); 